import React, { useState } from "react";
import Header from "../Home/Header/Header";
import CustomTextField from "../../TextFiled/Index";
import { Button } from "@mui/material";
import "./LiquidityTracker.scss";

const LiquidityTracker = () => {
  const [isExpandedOD, setIsExpandedOD] = useState(false);
  const [totalOD, setTotalOD] = useState("");
  const [usedOD, setUsedOD] = useState("");
  const [calculatedOD, setCalculatedOD] = useState("");

  const [isExpandedLoan, setIsExpandedLoan] = useState(false);
  const [totalLoan, setTotalLoan] = useState("");
  const [usedLoan, setUsedLoan] = useState("");
  const [calculatedLoan, setCalculatedLoan] = useState("");

  const handleToggleOD = () => {
    setIsExpandedOD(!isExpandedOD);
  };

  const handleSaveOD = () => {
    if (!totalOD || !usedOD || isNaN(totalOD) || isNaN(usedOD)) {
      alert("Please enter valid numbers for Total and Used (OD/CC).");
      return;
    }
    const difference = parseFloat(totalOD) - parseFloat(usedOD);
    setCalculatedOD(difference);
    setIsExpandedOD(false);
  };

  const handleToggleLoan = () => {
    setIsExpandedLoan(!isExpandedLoan);
  };

  const handleSaveLoan = () => {
    if (!totalLoan || !usedLoan || isNaN(totalLoan) || isNaN(usedLoan)) {
      alert("Please enter valid numbers for Total and Used (Loan).");
      return;
    }
    const difference = parseFloat(totalLoan) - parseFloat(usedLoan);
    setCalculatedLoan(difference);
    setIsExpandedLoan(false);
  };

  return (
    <div>
      <Header otherPage={true} title="Liquidity Tracker" />
      <div className="liquidity-tracker">
        <div className="liquidity-content">
          <div className="liquidity-row">
            <span className="liquidity-type">Cash</span>
            <span className="liquidity-value">2,30,15,201.50</span>
          </div>
          <div className="liquidity-row">
            <span className="liquidity-type">Bank</span>
            <span className="liquidity-value">2,30,15,201.50</span>
          </div>
          <div className="liquidity-row">
            <span className="liquidity-type">Stock</span>
            <span className="liquidity-value">2,30,15,201.50</span>
          </div>
          <div className="liquidity-row">
            <span className="liquidity-type">RM Stock (Metal)</span>
            <span className="liquidity-value">2,30,15,21,12,201.50</span>
          </div>

          {/* OD/CC Section */}
          <div className="liquidity-row">
            <span className="liquidity-type">OD/CC</span>
            <div className="liquidity-actions">
              <Button
                variant="contained"
                onClick={handleToggleOD}
                className="btn-add"
              >
                {isExpandedOD ? "Cancel" : "Add"}
              </Button>
            </div>
            <span className="liquidity-value">
              {calculatedOD !== "" ? calculatedOD : ""}
            </span>
          </div>
          {isExpandedOD && (
            <div className="liquidity-inputs">
              <CustomTextField
                label="Total (OD/CC)"
                value={totalOD}
                onChange={(e) => setTotalOD(e.target.value)}
                variant="outlined"
                size="small"
              />
              <CustomTextField
                label="Used (OD/CC)"
                value={usedOD}
                onChange={(e) => setUsedOD(e.target.value)}
                variant="outlined"
                size="small"
              />
              <Button variant="contained" color="primary" onClick={handleSaveOD}>
                Save
              </Button>
            </div>
          )}
          <div className="liquidity-row">
            <span className="liquidity-type">Loan</span>
            <div className="liquidity-actions">
              <Button
                variant="contained"
                onClick={handleToggleLoan}
                className="btn-add"
              >
                {isExpandedLoan ? "Cancel" : "Add"}
              </Button>
            </div>
            <span className="liquidity-value">
              {calculatedLoan !== "" ? calculatedLoan : ""}
            </span>
          </div>
          {isExpandedLoan && (
            <div className="liquidity-inputs">
              <CustomTextField
                label="Total (Loan)"
                value={totalLoan}
                onChange={(e) => setTotalLoan(e.target.value)}
                variant="outlined"
                size="small"
              />
              <CustomTextField
                label="Used (Loan)"
                value={usedLoan}
                onChange={(e) => setUsedLoan(e.target.value)}
                variant="outlined"
                size="small"
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveLoan}
              >
                Save
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiquidityTracker;
